import { useEffect } from 'react';

import { PAGE_META, SITE_URL } from './site';

const setAttribute = (selector, attribute, value) => {
  const element = document.querySelector(selector);
  if (element) {
    element.setAttribute(attribute, value);
  }
};

// The server answers every route with the prerendered home HTML (`serve -s`),
// so each page corrects its title, description, canonical URL and robots
// directive once it mounts; crawlers that run JavaScript (Google, Bing) index
// the page under its own URL instead of as a copy of the home page.
const usePageMeta = (path) => {
  useEffect(() => {
    const meta = PAGE_META[path];
    document.title = meta.title;
    setAttribute('meta[name="description"]', 'content', meta.description);
    setAttribute('link[rel="canonical"]', 'href', `${SITE_URL}${path === '/' ? '/' : path}`);
    setAttribute(
      'meta[name="robots"]',
      'content',
      meta.index ? 'index, follow, max-image-preview:large' : 'noindex, follow'
    );
  }, [path]);
};

export default usePageMeta;
